import { render, staticRenderFns } from "./MarketplacePlatformCell.vue?vue&type=template&id=7c904726&"
import script from "./MarketplacePlatformCell.vue?vue&type=script&lang=js&"
export * from "./MarketplacePlatformCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports